<template>
  <div v-if="tiles.length" class="job-insights mb-4">
    <div v-for="tile in tiles" :key="tile.key" class="job-insights__tile">
      <span class="job-insights__icon">
        <b-icon :icon="tile.icon" />
      </span>
      <div class="job-insights__text">
        <span class="job-insights__value">{{ tile.value }}</span>
        <span class="job-insights__label">{{ tile.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// Presentational stat tiles for job postings. Each tile is
// { key, label, value, icon }; the pages decide which numbers to show.
export default {
  name: 'JobInsights',

  props: {
    tiles: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss" scoped>
// Same tile look as CandidatesDashboardStats so the Hiring area reads as one.
.job-insights {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

@media (max-width: 991.98px) {
  .job-insights {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 575.98px) {
  .job-insights {
    grid-template-columns: 1fr;
  }
}

.job-insights__tile {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 1.1rem 1.25rem;
  border-radius: 12px;
  border: 1px solid #e1e6ea;
  background-color: #fff;
}

.job-insights__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background-color: #e6f0ff;
  color: #006cff;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.job-insights__text {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.job-insights__value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #212529;
  line-height: 1.2;
}

.job-insights__label {
  font-size: 0.78rem;
  color: #6c7581;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
